import angular from 'angular'

import MapSimple from '../utils/map-simple'
import StrictObj from '../utils/strict-obj'
import extractRawElm from '../utils/extract-raw-elm'

import { domInsert, getBlockNodes } from '../utils/angular-helpers'

const TRUE_STR = 'true'

angular
  .module('ggs.fast-switch')
  .factory('fastSwitchMap', FastSwitchMapProvider)
  .directive('ggsFastSwitch', FastSwitchDirective)
  .directive('ggsFastSwitchWhen', FastSwitchWhenDirective)

function FastSwitchMapProvider() {
  return MapSimple()
}

function FastSwitchDirective($parse, fastSwitchMap) {
  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      const elm = extractRawElm($elm)
      const regsIndex = fastSwitchMap.getIndex(elm)
      const regs = fastSwitchMap.getByIndex(regsIndex)
      fastSwitchMap.delByIndex(regsIndex)

      const ngExp = $parse($attr.ggsFastSwitch)
      const initValue = ngExp($scope)
      if (ngExp.oneTime && (initValue !== undefined)) {
        const $regTransclude = initValue ? regs.$trueTransclude : regs.$falseTransclude
        const $regElement = initValue ? regs.$trueElement : regs.$falseElement
        $regTransclude(($whenElm, _$whenScope) => {
          domInsert($whenElm, $regElement.parent(), $regElement)
        })
      } else {
        let $lastWhenElm = null
        let $lastWhenScope = null
        $scope.$watch(ngExp, (nextValue) => {
          // remove prev
          if ($lastWhenScope) {
            $lastWhenScope.$destroy()
            $lastWhenScope = null
          }
          if ($lastWhenElm) {
            getBlockNodes($lastWhenElm).remove()
            $lastWhenElm = null
          }
          // launch next
          if (nextValue !== undefined) {
            const $regTransclude = nextValue ? regs.$trueTransclude : regs.$falseTransclude
            const $regElement = nextValue ? regs.$trueElement : regs.$falseElement
            $regTransclude(($whenElm, $whenScope) => {
              $lastWhenElm = $whenElm
              $lastWhenScope = $whenScope
              domInsert($whenElm, $regElement.parent(), $regElement)
            })
          }
        })
      }
    }
  }
}

function FastSwitchWhenDirective(fastSwitchMap) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link(_$scope, $elm, $attr, _$ctrl, $transclude) {
      const parentElm = extractRawElm($elm).parentNode
      const parentIndex = fastSwitchMap.getIndex(parentElm)
      const parentRegs = parentIndex !== -1
        ? fastSwitchMap.getByIndex(parentIndex)
        : fastSwitchMap.set(parentElm, StrictObj({}))

      const when = $attr.ggsFastSwitchWhen

      if (when === TRUE_STR) {
        parentRegs.$trueElement = $elm
        parentRegs.$trueTransclude = $transclude
      } else {
        parentRegs.$falseElement = $elm
        parentRegs.$falseTransclude = $transclude
      }
    }
  }
}
